export const getUserType = (user) =>
  user?.attributes?.profile?.publicData?.userType;

export const confirmUserType = (user, requestedUserType) => {
  const userType = getUserType(user);

  return userType === requestedUserType;
};
